import Body from 'commons/card/Body';
import { default as Card } from 'commons/card/CollapsableCard';
import ErrorCard from 'commons/card/ErrorCard';
import Header from 'commons/card/Header';
import LoadingCard from 'commons/card/LoadingCard';
import UrlFormatter from 'commons/filters/UrlFormatter';
import EmptyResult from 'commons/status/EmptyResult';
import GenericGrid from 'pages/tables/GenericGrid';
import React, { Fragment, useState } from 'react';
import CreateMessagesModal from './components/modals/CreateMessagesModal';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useAddAnnonceMutation, useGetAnnoncesQuery, useRemoveAnnonceMutation } from '../../redux/api/cache';

export default function MessagesContainer() {
  const [createModal, setCreateModal] = useState(false);
  const [query, setQuery] = useState(undefined);
  const [selectedRow, setSelectedRow] = useState(undefined);
  const navigate = useNavigate();
  const location = useLocation();
  const { data: annonces, isError, isLoading } = useGetAnnoncesQuery({ query });
  const [addAnnonce] = useAddAnnonceMutation();
  const [removeAnnonce] = useRemoveAnnonceMutation();

  const remove = async () => {
    let result = await removeAnnonce({ ann_num: selectedRow.ann_num }).unwrap();
    if (result.success) updateQuery('');
  };

  const updateQuery = (newQuery) => {
    setQuery(newQuery);
  };

  const update = async (res) => {
    if (res.success) fileClicked(res.data[0]);
  };

  const create = async (values) => {
    let result = await addAnnonce(values).unwrap();
    if (result.success)
      update(result);
  };

  const fileClicked = (rowData) => {
    navigate(location.pathname + '/Numero=' + rowData.ann_num, {
      state: {
        rowData: rowData
      },
    });
  };

  return (
    <Fragment>
      <UrlFormatter
        canAdd={true}
        title="Recherche"
        titleButton="Ajouter une annonce"
        dates={[]}
        inputs={[{ label: 'Numéro', key: 'ann_num' }]}
        updateQuery={updateQuery}
        create={() => {
          setSelectedRow(undefined);
          setCreateModal(!createModal);
        }}
      />
      {isLoading && !isError ? <LoadingCard title="Recherche..." /> : null}
      {!isLoading && isError ? <ErrorCard title="Annonce" /> : null}
      {!isLoading && !isError && annonces && (
        <Fragment>
          {createModal && (
            <CreateMessagesModal
              selectedRow={selectedRow}
              create={create}
              remove={remove}
              toggleDialog={() => {
                setCreateModal(!createModal);
              }}
            />
          )}
          {annonces?.data?.length > 0 && (
            <Card canCollapse={false}>
              <Header
                title={`${annonces?.data?.length} Annonces trouvés`}
              ></Header>
              <Body>
                <GenericGrid
                  autoSize={true}
                  showCreateBtn={false}
                  rowClicked={fileClicked}
                  definition={annonces.meta.definition}
                  data={annonces.data}
                ></GenericGrid>
              </Body>
            </Card>
          )}
        </Fragment>
      )}
      {!isLoading && !isError && annonces?.data?.length === 0 && (
        <EmptyResult
          title={'Aucune annonce trouvé'}
          message={' veuillez affiner votre recherche'}
        />
      )}
    </Fragment>
  );
}
